import React from 'react';
import { ContactInformation } from '@tcs/client-portal-api/types/ContactInformation';
import DetailCard, {
  DetailCardItem,
} from '@tcs/common/components/molecules/DetailCard';
import formatPhone from '@tcs/common/utils/formatPhone';
import { Unicode } from '@tcs/common/utils/unicode';

interface ContactInfoCardProps {
  contactInfo: ContactInformation;
}

const ContactInfoCard = ({ contactInfo }: ContactInfoCardProps) => {
  return (
    <DetailCard title="Contact Information">
      <DetailCardItem label="Email" value={contactInfo?.email} isPrivate />
      <DetailCardItem
        label="Primary Phone Number"
        value={formatPhone(contactInfo?.primaryPhone) || Unicode.EmDash}
        isPrivate
      />
      <DetailCardItem
        label="Secondary Phone Number"
        value={formatPhone(contactInfo?.secondaryPhone) || Unicode.EmDash}
        isPrivate
      />
    </DetailCard>
  );
};

export default ContactInfoCard;
